import { apiMiddleware } from "./apiMiddleware"

export interface IntakeQuestion {
  key: string
  label: string
  kind: "text" | "yes_no" | "textarea"
  required: boolean
}

export interface IntakeFormPayload {
  error: boolean
  prefill: { first_name: string; last_name: string; phone: string; email: string }
  questions: IntakeQuestion[]
}

export interface IntakeFieldErrors {
  [key: string]: string[]
}

const PUBLIC = { skipAuth: true }

export const intakeApi = {
  getForm(token: string): Promise<IntakeFormPayload> {
    return apiMiddleware.get<IntakeFormPayload>(`intake/?token=${encodeURIComponent(token)}`, PUBLIC)
  },
  submit(token: string, answers: Record<string, string>): Promise<{ error: boolean; message?: string; fields?: IntakeFieldErrors }> {
    return apiMiddleware.post(`intake/`, { token, answers }, PUBLIC)
  },
}
